import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Field } from 'redux-form'

import { renderTextField } from '../../Forms/fieldRenderers'
import { isDecimal, required } from '../../Forms/fieldValidators'

export class OperacionesModificacionCubicajeSiloDialogView extends Component {
  render () {
    const {
      silo
    } = this.props
    return (
      <div>
        <Row>
          <Col md={12}>
            <h2>Modificar fumigado de {silo.nombreCorto}</h2>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              name='metrosDeVacio'
              label='Metros De vacio'
              type='number'
              component={renderTextField}
              validate={[required, isDecimal]}
              placeholder=''
            />
          </Col>
          <Col md={6}>
            <Field
              name='ph'
              label='ph'
              type='number'
              component={renderTextField}
              validate={[isDecimal]}
              placeholder=''
            />
          </Col>
        </Row>
      </div>
    )
  }
}
